module.exports = __webpack_public_path__ + "static/media/iconFB.3436e2bd.svg";